import Main from './index.vue'
export default Main
